import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ActionWorkflow } from '../services/WorkflowService';

const CampaignActionPage = () => {
    const query = new URLSearchParams(useLocation().search);

    const [requestId] = useState(query.get('requestId'));
    const [transitionId] = useState(query.get('transitionId'));
    const [actionId] = useState(query.get('actionId'));
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (requestId && transitionId && actionId) {
            ActionWorkflow(requestId, transitionId, actionId)
                .then((response) => {
                    setMessage(response);
                })
                .catch((error) => {
                    setErrorMessage(`${error.response.data}`);
                });
        }
    }, [requestId, transitionId, actionId]);

    const showMessage = () => {
        if (errorMessage !== '') {
            return <span>{window.translate(errorMessage)}</span>;
        }

        return <span>{message !== '' ? window.translate(message) : window.translate('Processing your action.  Please wait.')}</span>;
    };

    return <div>{showMessage()}</div>;
};

export default CampaignActionPage;
